<div class="canvas-container">
  <canvas id="{{ chartId }}" [attr.height]="height"></canvas>
</div>

<div
  id="cumul_income_tooltip"
  *ngIf="id.startsWith('cumul_income')"
  class="tooltip"
>
  <div *ngFor="let p of tooltipDataPoints">
    <div class="title" *ngIf="p.dataset.code == 'CUR_MONTH'">
      {{ getCurDateLabel(p.label) }}
    </div>
    <div class="value" [class.blue]="p.dataset.code == 'CUR_MONTH'">
      {{ p.formattedValue }}
      {{ displayUnit ? p.dataset.unitDescr[p.dataIndex] : "" }}
    </div>
  </div>
</div>

<div
  id="periodic_profit_tooltip"
  *ngIf="id.startsWith('periodic_profit')"
  class="tooltip"
>
  <div *ngFor="let p of tooltipDataPoints">
    <p class="label" *ngIf="!p.dataset.code.includes('PROFIT')">
      {{ p.dataset.label }}:
    </p>

    <span class="value" [class.blue]="p.dataset.code == 'CUR_INCOME'">
      {{ p.formattedValue }}
      ש"ח
    </span>

    <p *ngIf="p.dataset.code == 'CUR_PROFIT'" class="profit">
      {{ profit.values2[p.dataIndex] | number }}%
    </p>
    <p *ngIf="p.dataset.code == 'PAST_PROFIT'" class="profit">
      {{ profitPrev.values2[p.dataIndex] | number }}%
    </p>
  </div>
</div>

<div
  id="digital_orders_tooltip"
  *ngIf="id.startsWith('digital_orders')"
  class="tooltip"
>
  <div *ngIf="tooltipDataPoints.length > 0" class="container">
    <div class="col">
      <div class="row">
        <span class="pct">{{
          analogPct.values[tooltipDataPoints[0].dataIndex] / 100 | percent
        }}</span>
        <span
          class="delta-pct"
          [class.red]="
            analogColorCode.txtValues[tooltipDataPoints[0].dataIndex] == 'RED'
          "
          [class.green]="
            analogColorCode.txtValues[tooltipDataPoints[0].dataIndex] == 'GREEN'
          "
        >
          {{ analogDeltaPct.values[tooltipDataPoints[0].dataIndex] | percent }}
          <i
            class="fas"
            [class.fa-arrow-up]="
              analogColorCode.txtValues[tooltipDataPoints[0].dataIndex] ==
              'GREEN'
            "
            [class.fa-arrow-down]="
              analogColorCode.txtValues[tooltipDataPoints[0].dataIndex] == 'RED'
            "
          ></i>
        </span>
      </div>
      <p>
        {{ analogCnt.values[tooltipDataPoints[0].dataIndex] | number }} עבודות
        אנלוגיות
      </p>
    </div>

    <div class="separator"></div>

    <div class="col">
      <div class="row">
        <span class="pct">{{
          digitalPct.values[tooltipDataPoints[0].dataIndex] / 100 | percent
        }}</span>
        &nbsp;
        <span
          class="delta-pct"
          [class.red]="
            digitalColorCode.txtValues[tooltipDataPoints[0].dataIndex] == 'RED'
          "
          [class.green]="
            digitalColorCode.txtValues[tooltipDataPoints[0].dataIndex] ==
            'GREEN'
          "
          >{{
            digitalDeltaPct.values[tooltipDataPoints[0].dataIndex] | percent
          }}
          <i
            class="fas"
            [class.fa-arrow-up]="
              digitalColorCode.txtValues[tooltipDataPoints[0].dataIndex] ==
              'GREEN'
            "
            [class.fa-arrow-down]="
              digitalColorCode.txtValues[tooltipDataPoints[0].dataIndex] ==
              'RED'
            "
          ></i
        ></span>
      </div>
      <p>
        {{ digitalCnt.values[tooltipDataPoints[0].dataIndex] | number }} עבודות
        בסריקה
      </p>
    </div>
  </div>
</div>

<div id="try_in_tooltip" *ngIf="id.startsWith('try_in')" class="tooltip">
  <div *ngFor="let p of tooltipDataPoints">
    <p class="fw-bold">{{ p.dataset.values2[p.dataIndex] | number }} עבודות</p>
    <span class="profit">{{ p.formattedValue }}%</span>
  </div>
</div>

<div id="returns_tooltip" *ngIf="id.startsWith('returns')" class="tooltip">
  <div *ngFor="let p of tooltipDataPoints">
    <p class="fw-bold">{{ p.dataset.values2[p.dataIndex] | number }} עבודות</p>
    <span class="profit">{{ p.formattedValue }}%</span>
  </div>
</div>

<div id="fix_tooltip" *ngIf="id.startsWith('fix')" class="tooltip">
  <div *ngFor="let p of tooltipDataPoints">
    <p class="fw-bold">{{ p.dataset.values2[p.dataIndex] | number }} עבודות</p>
    <span class="profit">{{ p.formattedValue }}%</span>
  </div>
</div>
